import React from 'react';
import { getText } from '../i18n';

export default function DailyFlagBoard({ guesses, language }) {
  if (!guesses || guesses.length === 0) {
    return null;
  }

  return (
    <div className="daily-board">
      <div className="daily-board-header">{getText('dailyBoardTitle', language)}</div>
      <div className="daily-board-grid">
        {guesses.map((row, index) => (
          <div key={index} className="daily-board-row">
            <span className="daily-board-text">{row.guess}</span>
            <span className={`daily-board-status ${row.correct ? 'correct' : 'wrong'}`}>
              {row.correct ? '✓' : '✕'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
